import React from 'react';
import { FormLabel, Stack } from '@carbon/react';
import IconSelector from 'src/components/Form/IconSelector';
import DndUploader from 'src/components/Uploader/DNDUploader';
import { resolveIconUrl } from 'src/utils/images';

interface FormFieldIconProps {
  value: string;
  presets: string[];
  onChange: (value: string) => void;
  label: string;
}

/**
 * Presets and upload in one control. The presets cover the common case in one click; the
 * uploader is for a restaurant that wants its own artwork. Both write the same field, told
 * apart by a leading slash — see `resolveIconUrl`.
 */
const FormFieldIcon = React.memo(({ value, presets, onChange, label }: FormFieldIconProps) => {
  const uploadedUrl = value?.startsWith('/') ? null : resolveIconUrl(value);

  return (
    <Stack gap={3}>
      <FormLabel>{label}</FormLabel>
      <IconSelector value={value} onChange={onChange} icons={presets} />
      {uploadedUrl && <img className="form-field-icon__preview" src={uploadedUrl} alt="" />}
      <DndUploader
        useCropper
        initialValue={null}
        cropperAspectRatio={1}
        previewAspectRatio="1x1"
        onChange={({ fileId }) => onChange(fileId)}
      />
    </Stack>
  );
});

export default FormFieldIcon;
